import React from "react";
import { Text, Flex, Card } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors } from "@jsq/ds/styles";

type Props = {
  text: string;
  subtitle?: string;
};

const EmptyState = (props: Props) => {
  return (
    <Card style={{ border: "none" }}>
      <Flex
        style={{ minHeight: "170px", marginTop: "24px" }}
        flexDirection="column"
        alignItems="center"
        justifyContent="space-between"
      >
        <Icon type="inbox" size="xxx-large" color={Colors.Neutral600} />
        <Text variant="strong-xl">{props.text}</Text>
        <Text style={{ maxWidth: "680px" }} align="center" variant="secondary-md">
          {props.subtitle || ""}
        </Text>
        {/* )} */}
      </Flex>
    </Card>
  );
};

export default EmptyState;
